import { useContext, useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router";
import { Grid } from "@mui/material";
import { useTranslation } from "react-i18next";
import { toast } from "react-toastify";
import axios from "axios";
import { navigateToLoginPage } from "../../../../utils/utility";
import BASE_URL from "../../../../constants/baseUrls";
import { LocaleContext } from "../../../../routing/LangRouter";
import { InfoCircle } from "iconsax-react";
import useDebouncedInputChange from "../../../../hooks/useDebouncedInputChange ";

//import general components
import BaseTitle from "../../../common/base-title/base-title";
import BaseTextField from "../../../common/base-text-field/base-text-field";
import BasePagination from "../../../common/base-pagination/base-pagination";
import Loading from "../../../common/loading/loading";
import EmptyOrErrorState from "../../../common/empty-or-error-state/empty-or-error-state";

//import view components
import SmartReservationCard from "./smart-reservation-card";

export default function NotifyMe() {
    const navigate = useNavigate();
    const location = useLocation();
    const { locale } = useContext(LocaleContext);
    const { t } = useTranslation();
    const accessToken = localStorage.getItem("accessToken");

    const [notifications, setNotifications] = useState(null);
    const [isLoading, setIsLoading] = useState(false);

    const [searchValue, setSearchValue] = useState("");
    // Handle search value change
    const handleSearchChange = event => {
        const { value } = event.target;
        setSearchValue(value);
        setPage(1);
        debouncedOnChange(value);
    };
    const debouncedOnChange = useDebouncedInputChange(input => {
        getNotifyMe(input, 1);
    }, 1000);

    const getNotifyMe = async (search, page) => {
        try {
            setIsLoading(true);
            const response = await axios.get(`${BASE_URL}/notification/manage/`, {
                params: {
                    search,
                    page,
                },
                headers: {
                    Authorization: `Bearer ${accessToken}`,
                },
            });
            setNotifications(response.data.data);
        } catch (error) {
            if (error.response.status === 401) {
                localStorage.clear();
                navigateToLoginPage(navigate, locale, location);
            } else {
                toast.error(t("Toast Messages.Error Occurred"), { toastId: "custom-id-yes" });
            }
        } finally {
            setIsLoading(false);
        }
    };

    const [page, setPage] = useState(notifications?.current_page ?? 1);
    const handlePaginationChange = async (event, value) => {
        setPage(value);
        getNotifyMe(searchValue, value);
    };

    useEffect(() => {
        getNotifyMe(searchValue, page);
    }, []);

    if (isLoading) return <Loading />;

    return (
        <Grid container item xs={12} rowGap={2}>
            <BaseTitle title={t("User Panel.notifyMe")} dividerColor="1px solid var(--medium-gray-color)" />
            <Grid container item md={4}>
                <BaseTextField label={t("search")} size="medium" radius="10px" value={searchValue} setValue={e => handleSearchChange(e)} />
            </Grid>
            <Grid container item xs={12} rowGap={2} justifyContent="center">
                {!!notifications?.results?.length ? (
                    <>
                        {notifications?.results?.map(item => (
                            <SmartReservationCard
                                key={item?.id}
                                item={item}
                                type="notifyMe"
                                fetchData={getNotifyMe}
                                description={t("Messages.deleteReservationWarning")}
                            />
                        ))}

                        <BasePagination
                            count={notifications?.total_pages}
                            page={notifications?.current_page ?? 1}
                            handleChange={handlePaginationChange}
                        />
                    </>
                ) : (
                    <EmptyOrErrorState
                        title={t("Messages.No Items to Display")}
                        icon={<InfoCircle size="32" color="var(--secondary-color)" variant="Bold" />}
                    />
                )}
            </Grid>
        </Grid>
    );
}
